<template>
    <!-- 确认关闭 -->
  <el-dialog
    :title="titleDialog"
    :visible.sync="closeCreditDialog"
    width="25%">
    <span style='padding-left:30px;'>{{content}}</span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onAffirm">确 认</el-button>
      <el-button @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateByCredit, settingStarUpdate } from '@/api/customer/customerManage'
export default {
  data () {
    return {
      closeCreditDialog: false,
      type: '',
      queryParams: {},
      titleDialog: '', // 弹窗标题
      content: '', // 弹窗内容
      isBool: false
    }
  },
  methods: {
    // 初始值
    onInitial (val, type) {
      if (val) {
        this.titleDialog = '确认打开'
        if (type === 'setStar') {
          this.content = '开启星级后当天无法立即生效，我们将会计算当前站内所有客户星级，第二天方可使用相关功能。'
        } else {
          this.content = '开启信用后当天无法立即生效，我们将会计算当前站内所有客户信用等级，第二天方可使用相关功能。'
        }
      } else {
        this.titleDialog = '确认关闭'
        if (type === 'credit') {
          this.content = '确认关闭客户信用模块'
        } else {
          this.content = '确认关闭客户星级模块'
        }
      }
      this.type = type
      this.closeCreditDialog = true
      this.isBool = val
    },
    // 确认
    onAffirm () {
      if (this.type === 'credit') {
        updateByCredit(this.isBool).then(res => { // 信用开关
          if (res.data.code === 200) {
            this.$emit('onRefresh', this.type)
            this.closeCreditDialog = false
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        settingStarUpdate(this.isBool).then(res => { // 星级开关
          if (res.data.code === 200) {
            this.$emit('onRefresh', this.type)
            this.closeCreditDialog = false
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    // 取消
    close () {
      this.closeCreditDialog = false
    }
  }
}
</script>
